
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesReturnGrid extends Serenity.EntityGrid<ECommSalesReturnRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesReturn'; }
        protected getDialogType() { return ECommSalesReturnDialog; }
        protected getIdProperty() { return ECommSalesReturnRow.idProperty; }
        protected getInsertPermission() { return ECommSalesReturnRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesReturnRow.localTextPrefix; }
        protected getService() { return ECommSalesReturnService.baseUrl; } 
        private autoSize; 
        constructor(container: JQuery) {
            super(container); 
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
        }
        protected addButtonClick() {
            
            let now = new Date();
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[88].AutoPosting;

            var userDefinition = Q.Authorization.userDefinition;

            var voucher = FormatHelper.GetVoucherNo(88);

            this.editItem(<ECommSalesReturnRow>{
                VoucherNo: voucher,
                Line_No: 0,
                CompanyId:userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 88,
                AutoPosting: autoposting
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        } 
         
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}